import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, Link } from 'react-router-dom';
import $ from 'jquery';
import { useNavigate} from 'react-router-dom';
import api from '../../api/axiosInstance';
function ViewCategory() {
    debugger;
    const { id } = useParams();
    const [category, setCategory] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({ name: '', description: '' });
    const [newSubCategory, setNewSubCategory] = useState({ name: '', description: '' });
        const navigate = useNavigate();

    useEffect(() => {
        const fetchCategory = async () => {
            try {
                const response = await api.get(`/Administration/ViewFormCategory?id=${id}`);
                setCategory(response.data);
            } catch (error) {
                console.error("Error fetching category:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategory();
    }, [id]);

    useEffect(() => {
        if (!loading && category?.formSubCategories?.length > 0 && window.$ && $.fn && $.fn.DataTable) {
            const selector = '#example1';

            //  Destroy existing DataTable instance (if it exists)
            if ($.fn.DataTable.isDataTable(selector)) {
                $(selector).DataTable().clear().destroy();
            }

            // Initialize a new instance
            $(selector).DataTable({
                responsive: true,
                autoWidth: false,
                searching: true,
                ordering: true,
                sorting: true,
                pageLength: 10,
                lengthChange: false,
                paging: true,
                info: true,
            });
        }

        // Cleanup on component unmount or dependency change
        return () => {
            if ($.fn && $.fn.DataTable && $.fn.DataTable.isDataTable('#example1')) {
                $('#example1').DataTable().clear().destroy();
            }
        };
    }, [loading]);



    const handleChange = (e) => {
        const { id, value } = e.target;
        setCategory((prevCategory) => ({
            ...prevCategory,
            [id]: value
        }));
    };

    const handleNewSubCategoryChange = (e) => {
        const { id, value } = e.target;
        setNewSubCategory((prev) => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSave = async () => {
        let hasErrors = false;
        const newErrors = { name: '', description: '' };

        if (!category.name) {
            newErrors.name = 'Form Category Name is required.';
            hasErrors = true;
        }
        if (!category.description) {
            newErrors.description = 'Description is required.';
            hasErrors = true;
        }

        setErrors(newErrors);

        if (!hasErrors) {
            try {
                await api.put(`/Administration/EditFormCategory`, {
                    Id: id,
                    Name: category.name,
                    Description: category.description,
                });
                $.alert({
                    title: "Success",
                    content: "Record saved successfully",
                    type: "green",
                    buttons: {
                        okay: {
                            text: 'Ok',
                            btnClass: 'btn-green',
                            action: function () {
                                // Refresh the category data after deletion
                                api.get(`/Administration/ViewFormCategory?id=${id}`)
                                    .then(fetchResponse => {
                                        setCategory(fetchResponse.data);

                                    });
                            }
                        }
                    }
                });
            } catch (error) {
                console.error("Error saving category:", error);
                alert('Error saving record');
            }
        }
    };

    const handleAddSubCategory = async () => {
        let hasErrors = false;
        const newErrors = { name: '', description: '' };

        if (!newSubCategory.name) {
            newErrors.name = 'Subcategory Name is required.';
            hasErrors = true;
        }
        if (!newSubCategory.description) {
            newErrors.description = 'Description is required.';
            hasErrors = true;
        }

        setErrors(newErrors);

        if (!hasErrors) {
            try {
                // Add new subcategory
                await api.post(`/Administration/AddFormSubCategory`, {
                    FormCategoryId: id,
                    FormCategoryName: category.name,
                    Name: newSubCategory.name,
                    Description: newSubCategory.description,
                });

 const modal = document.getElementById('modal-default');
                                modal.style.display = 'none'; 
                                 modal.classList.remove('show');// Close the modal
                                const backdrop = document.querySelector('.modal-backdrop');
                                if (backdrop) {
                                    backdrop.remove();
                                }
                                   document.body.classList.remove('modal-open');
                // Close the modal using Bootstrap's modal API
                // Show success alert
                $.confirm({
                    title: 'Success',
                    content: 'Record saved successfully',
                    type: 'green',
                    buttons: {
                        okay: {
                            text: 'Ok',
                            btnClass: 'btn-green',
                            action: () => {
                                  api.get(`/Administration/ViewFormCategory?id=${id}`)
                                                .then(fetchResponse => {
                                                    setCategory(fetchResponse.data);
                                                         setNewSubCategory({ name: '', description: '' });
                                                });
                            },
                        },
                    },
                });

            } catch (error) {
                console.error("Error adding subcategory:", error);
                alert('Error adding subcategory');
            }
        }
    };

    const handleDelete = (subCategoryId) => {
        $.confirm({
            title: 'Confirm Deletion',
            content: 'Do you really want to delete this?',
            buttons: {
                cancel: {
                    text: 'Cancel',
                    btnClass: 'btn-red',
                    action: function () {
                        // Do nothing on cancel
                    }
                },
                confirm: {
                    text: 'Yes, delete it!',
                    btnClass: 'btn-green',
                    action: async function () {
                        try {
                            const response = await api.delete(`/Administration/DeleteFormSubCategory/${subCategoryId}`);

                            // Success alert
                            $.alert({
                                title: 'Success!',
                                content: response.data,
                                type: 'green',
                                buttons: {
                                    okay: {
                                        text: 'Ok',
                                        btnClass: 'btn-green',
                                        action: function () {
                                            // Refresh the category data after deletion
                                            api.get(`/Administration/ViewFormCategory?id=${id}`)
                                                .then(fetchResponse => {
                                                    setCategory(fetchResponse.data);
                                                });
                                        }
                                    }
                                }
                            });
                        } catch (error) {
                            if (error.response && error.response.status === 409) {
                                $.alert({
                                    title: 'Error!',
                                    content: error.response.data,
                                    type: 'red',
                                });
                            } else {
                                $.alert({
                                    title: 'Error!',
                                    content: 'Error deleting subcategory',
                                    type: 'red',
                                });
                            }
                        }
                    }
                }
            }
        });
    };

    if (loading) {
        return (
            <div className="loading-container" style={{ textAlign: 'center', marginTop: '150px' }}>
                <div className="spinner-border" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="sr-only">Loading...</span>
                </div>
                <h4 style={{ marginTop: '20px' }}>Loading Form Category Details, please wait...</h4>
            </div>
        );
    }

    if (!category) {
        return (
            <div className="alert alert-warning text-center" style={{ marginTop: '20px' }}>
                <h4>🔍 Category Not Found</h4>
                <p>The category you are looking for does not exist.</p>
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>View Form Category</title>
            </Helmet>

            <div>
                <div className="card card-success">
                    <div className="card-header">
                        <h3 className="card-title">Form Category</h3>
                    </div>
                    <div className="card-body">
                        <div className='form-group'>
                            <label htmlFor="name">Form Category Name</label>
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                maxLength={100}
                                value={category.name}
                                onChange={handleChange}
                            />
                            {errors.name && <span className='text-danger'>{errors.name}</span>}
                        </div>
                        <div className='form-group'>
                            <label htmlFor="description">Description</label>
                            <textarea
                                className="form-control"
                                id="description"
                                rows={4}
                                value={category.description || ''}
                                onChange={handleChange}
                            />
                            {errors.description && <span className='text-danger'>{errors.description}</span>}
                        </div>
                    </div>
                    <div className="card-footer">
                        <button type="button" className="btn btn-success" onClick={handleSave}>
                            Save
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <Link to="/editor/FormCategories" className="btn btn-danger">Cancel</Link>
                    </div>
                </div>

                <div className="card card-success">
                    <div className="card-header" style={{ display: 'flex', flexDirection: 'column' }}>
                        <h3 className="card-title">Form Sub Categories</h3>

                    </div>

                    <div className="row">
                        <div className="col-sm-3">
                            <div >
                                <button
                                    className='btn btn-success btn-sm'
                                    style={{ margin: '10px 0px 0px 20px' }}
                                    title='Add Category'
                                    data-toggle="modal"
                                    data-target="#modal-default">
                                    <i className='fa fa-write'></i> New
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">

                        <table id="example1" className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Created On</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {category.formSubCategories.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="text-center">
                                            No subcategories available.
                                        </td>
                                    </tr>
                                ) : (category.formSubCategories.map(subCategory => (
                                    <tr key={subCategory.id}>
                                        <td>{subCategory.name}</td>
                                        <td>{subCategory.description || 'N/A'}</td>
                                        <td>{new Date(subCategory.createdOn).toLocaleString() || 'N/A'}</td>
                                        <td>
                                            <button className='btn btn-xs btn-danger' title='Delete' onClick={() => handleDelete(subCategory.id)}>
                                                <i className='fa fa-trash'></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Created On</th>
                                    <th>Action</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                </div>
            </div>

            {/* Modal for adding new subcategory */}
            <div className="modal fade" id="modal-default">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add New Subcategory</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='form-group'>
                                <label htmlFor="newName">Subcategory Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    maxLength={100}
                                    value={newSubCategory.name}
                                    onChange={handleNewSubCategoryChange}
                                />
                                {errors.name && <span className='text-danger'>{errors.name}</span>}
                            </div>
                            <div className='form-group'>
                                <label htmlFor="newDescription">Description</label>
                                <textarea
                                    className="form-control"
                                    id="description"
                                    rows={4}
                                    value={newSubCategory.description}
                                    onChange={handleNewSubCategoryChange}
                                />
                                {errors.description && <span className='text-danger'>{errors.description}</span>}
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" className="btn btn-default" data-dismiss="modal" >Close</button>
                            <button type="button" className="btn btn-primary" onClick={handleAddSubCategory}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ViewCategory;
